<template>
  <section
    :id="sectionId || undefined"
    class="landing-section"
    :class="{
      'landing-section--band': variant === 'band' || variant === 'band-top',
      'landing-section--band-top': variant === 'band-top'
    }"
  >
    <v-container class="landing-section__inner pa-0">
      <div class="section-eyebrow">
        <span class="section-num bg-msq-yellow">{{ meta.numeral }}</span>
        <span>{{ meta.eyebrow }}</span>
      </div>

      <!-- Static, author-controlled marketing copy (no user input) -->
      <!-- eslint-disable-next-line vue/no-v-html -->
      <h2 v-if="meta.headlineHtml" class="section-headline" v-html="meta.headlineHtml"></h2>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-if="meta.ledeHtml" class="section-lede text-medium-emphasis" v-html="meta.ledeHtml"></p>

      <slot />
    </v-container>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { SectionMeta } from './landingContent'

@Options({
  props: {
    meta: { type: Object, required: true },
    sectionId: { type: String, default: '' },
    variant: { type: String, default: 'default' } // 'default' | 'band' | 'band-top'
  }
})
export default class LandingSection extends Vue {
  meta!: SectionMeta
  sectionId!: string
  variant!: 'default' | 'band' | 'band-top'
}
</script>

<style scoped lang="scss">
.landing-section {
  padding: 96px 24px;
}
.landing-section--band {
  background: rgb(var(--v-theme-surface-band));
  border-top: 1px solid var(--l-border);
  border-bottom: 1px solid var(--l-border);
}
.landing-section--band-top {
  border-bottom: none;
}
.landing-section__inner {
  max-width: 1280px;
  margin: 0 auto;
}
.section-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--l-mono);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-primary));
  margin-bottom: 20px;
}
.v-theme--light .section-eyebrow {
  color: rgb(var(--v-theme-on-background));
}
.section-num {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
}
.section-headline {
  font-size: clamp(32px, 4.5vw, 52px);
  line-height: 1.08;
  font-weight: 700;
  letter-spacing: -0.022em;
  margin: 0 0 24px;
  max-width: 24ch;
  text-wrap: balance;
}
.section-lede {
  font-size: 18px;
  line-height: 1.55;
  max-width: 64ch;
  margin: 0 0 56px;
  text-wrap: pretty;
}
@media (max-width: 900px) {
  .landing-section {
    padding: 64px 20px;
  }
}
</style>
